var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAstropay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 126",
    style: {
      enableBackground: "new 0 0 400 126"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#20D5B3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.2,116.5l1.7-1c0.9,2,2.8,3,5.1,3c2.6,0,4.1-1.2,4.1-3c0-1.4-0.9-2.2-3-2.8l-2.7-0.7 c-3.1-0.7-4.7-2.2-4.7-4.5c0-2.8,2.3-4.8,6.1-4.8c3.1,0,5.3,1.3,6.1,3.1l-1.7,1c-0.8-1.4-2.4-2.2-4.5-2.2c-2.4,0-3.9,1-3.9,2.8 c0,1.3,0.8,2.1,3,2.7l2.7,0.7c3.3,0.8,4.7,2.3,4.7,4.6c0,2.9-2.3,5-6.3,5C91.6,120.4,89.2,118.9,88.2,116.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.1,103.2h2.1v16.9h-2.1V103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.9,103.2v16.9h-2.1v-13.7l-5.9,9.3h-1.8l-5.9-9.3v13.7h-2.1v-16.9h2.2l6.6,10.3l6.6-10.3H129.9 L129.9,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.5,108.4c0,3.2-2.1,5.2-5.7,5.2H137v6.5h-2.1v-16.9h6.9C145.5,103.2,147.5,105.2,147.5,108.4L147.5,108.4z  M145.3,108.4c0-2.3-1.1-3.3-3.7-3.3H137v6.6h4.6C144.2,111.7,145.3,110.7,145.3,108.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.3,118.1v2h-11.1v-16.9h2.1v14.9H162.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.4,118.1v2h-11.8v-16.9h11.6v2h-9.4v5.5h9v1.9h-9v5.6L177.4,118.1L177.4,118.1L177.4,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.5,117.1h2.1l-1.7,6.5h-1.6L181.5,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.7,103.2v16.9h-2.1v-13.7l-5.9,9.3H201l-5.9-9.3v13.7H193v-16.9h2.2l6.6,10.3l6.5-10.3H210.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.8,111.6c0-4.9,3.5-8.8,8.7-8.8s8.7,3.9,8.7,8.8s-3.5,8.8-8.7,8.8S214.8,116.5,214.8,111.6z M229.9,111.6 c0-3.9-2.6-6.8-6.4-6.8s-6.4,2.9-6.4,6.8s2.6,6.8,6.4,6.8S229.9,115.5,229.9,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.3,103.2v16.9h-2l-10.1-13.5v13.5h-2.1v-16.9h2l10.1,13.5v-13.5H250.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.2,118.1v2h-11.8v-16.9H267v2h-9.4v5.5h9v1.9h-9v5.6L267.2,118.1L267.2,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.2,103.2l-6.5,9.9v7h-2.1v-7l-6.5-9.9h2.4l5.2,8l5.2-8H284.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.9,118.8c0-0.8,0.6-1.4,1.4-1.4c0.9,0,1.5,0.6,1.5,1.4c0,0.9-0.6,1.5-1.5,1.5S282.9,119.7,282.9,118.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.5,4.3L3.2,81.5h15.5L26.1,59h21.3L55,81.5h15.8L44.5,4.3H29.5z M43.7,46.2H29.9l5.8-17 c0.4-1.2,0.8-2.3,1.1-3.5c0.4,1.2,0.7,2.4,1.1,3.6C37.9,29.3,43.7,46.2,43.7,46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.9,46.4c-7.1-2.8-7.9-4.1-7.9-6.2c0-2.6,2.2-4.2,5.7-4.2c4.2,0,7.4,1.7,9,2.6l3,1.9l4-12.2l-1.8-1.2 c-3.5-2.3-8.7-3.6-14.1-3.6C83,23.5,74.4,31,74.4,41.3c0,9.5,8.4,14.6,15.5,17.2s7.6,4.5,7.6,6.7c0,4.2-4.4,4.8-7.1,4.8 c-4.1,0-8.5-1.7-11-3.2l-3-1.8l-4,12.5l1.9,1.1c4.3,2.5,10.1,4,15.9,4c13.1,0,21.9-7.4,21.9-18.3C112.1,53.3,103.4,48.8,96.9,46.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.4,11.2l-14.7,4.5v8.8h-8v12.7h8v25.2c0,7,1.4,12.1,4.3,15.4c2.8,3.1,7.2,4.8,12.1,4.8 c4.5,0,7.7-0.9,9.2-1.4l2-0.7l-0.8-12.8l-3.4,1c-1,0.3-2.2,0.5-4.6,0.5c-1.8,0-4.2,0-4.2-7.2V37.2h13.4V24.5h-13.4L135.4,11.2 L135.4,11.2L135.4,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.6,24l-2.7-0.3c-0.8-0.1-1.6-0.2-2.6-0.2c-4.7,0-9,1.9-12.2,5.3l-0.2-4.2H153l0.2,3 c0.3,4.4,0.4,9.4,0.4,15.8v38.1h14.9V51.3c0-1.4,0.1-2.8,0.3-3.8c1.1-5.9,4.8-9.6,9.8-9.6c1.2,0,1.9,0,2.6,0.1l3.4,0.7V24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.9,23.5c-16.6,0-28.3,12.3-28.3,30s11.3,29.2,27.4,29.2c13.7,0,28.4-9.4,28.4-30.1 C239.4,35.4,228.1,23.5,211.9,23.5L211.9,23.5z M224.3,52.9c0,9.9-5.4,17.2-12.8,17.2s-12.7-7.1-12.7-16.9 c0-6.3,2.7-17.1,12.9-17.1C221.6,36.1,224.3,47.1,224.3,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.4,10.5c-4.9-4.4-12.3-6.7-21.9-6.7c-6.5,0-12.6,0.5-18.2,1.4L246,5.6v75.8h14.8V53.3 c1.5,0.1,3.1,0.2,4.6,0.2c10,0,18.5-3.1,23.9-8.7c4.2-4.3,6.3-10.1,6.3-17.2C295.6,20.7,293,14.6,288.4,10.5L288.4,10.5z  M280.7,28.1c0,10.8-9.5,12.4-15.1,12.4c-1.9,0-3.5-0.1-4.8-0.3V17c1.4-0.2,3.4-0.3,5.9-0.3C273.1,16.7,280.7,18.7,280.7,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341,66.4V47.2c0-15.3-7.9-23.7-22.3-23.7c-6.7,0-13.6,1.8-18.5,4.9l-1.9,1.2l4,11.8l3-2.1 c3.1-2.1,7.5-3.3,11.9-3.3c3,0,5.2,0.7,6.6,2.1c1.2,1.2,1.9,2.9,2.1,5.2c-11.6,0.3-20.2,3.1-25.4,8.3c-3.6,3.6-5.4,8.2-5.4,13.6 c0,8.7,6.4,17.5,18.5,17.5c5.2,0,10.1-1.7,13.9-4.6l0.4,3.4H342l-0.5-3.2C341.2,75.2,341,71.2,341,66.4L341,66.4z M316.1,70.2 c-2.2,0-5.9-0.8-5.9-6.1c0-2,0.6-3.7,1.9-4.9c1.7-1.7,5.6-3.7,14.3-3.9v6.1c0,0.4,0,1.3-0.3,2.1C325.1,66.5,321.8,70.2,316.1,70.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,24.5l-10.8,32c-0.3,0.8-0.5,1.6-0.8,2.4c-0.3-0.8-0.6-1.6-0.8-2.3l-11.8-32.2h-16.3L362,75.6l0.1,0.1 c0.3,0.7,0.4,1,0.5,1.2c-0.1,0.3-0.3,0.8-0.5,1.1c-1.8,3.8-4.4,7.3-7,9.4l-0.1,0.1c-3,2.5-6,3.7-7.2,4l-2.6,0.8l3.8,12.8l2.5-0.4 c1.5-0.3,6.8-1.5,12.8-6.6c7.3-6.4,12.1-16.6,18.4-33.3L398,24.5C398,24.5,382.1,24.5,382.1,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.7,25.6c9.6-9.8,25.9-15.7,43.6-15.7c6.9,0,13.6,0.9,20,2.6l0.5,0.1l11.3-3.4L128,7.3 c-9.7-3.7-20.8-5.6-32.3-5.6C79.1,1.7,63.5,5.7,52,13l-1.2,0.8l4.8,14C55.6,27.8,57.7,25.6,57.7,25.6z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAstropay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/astropay.8e350f2f430340b57c92cc1cad18c32e.svg";